// ── Predefined titles per feature + universal ──
const PREDEFINED_TITLES = {
  ghost_mannequin: [
    'Turn your photo into a ghost mannequin',
    'Ghost mannequin effect in seconds',
    'Remove the mannequin, keep the shape',
    'Professional flat lays without a studio',
    'Your clothing deserves a ghost mannequin',
  ],
  product_staging: [
    'Put your product in a real context',
    'Stage your product like a pro',
    'From boring to lifestyle in 1 click',
    'Context sells. Add it instantly.',
    'Your product in any scene, any vibe',
  ],
  animated_design: [
    'Turn your photo into a video',
    'Animate any product photo instantly',
    'Static to motion in one click',
    'Make your designs come alive',
    'Your photo, now in motion',
  ],
  ai_backgrounds: [
    'Give your product the background they deserve',
    'AI backgrounds that actually convert',
    'Swap backgrounds in seconds',
    'Studio-quality backgrounds, zero studio',
    'The background makes the sale',
  ],
  virtual_models: [
    'Put your product on virtual models',
    'AI models for your brand, instantly',
    'No photoshoot needed anymore',
    'Virtual models, real conversions',
    'Diverse models on demand',
  ],
  _universal: [
    'You have to see this!',
    'Best hack for business owners! \ud83d\udd25',
    "I can't believe I caught this on camera \ud83e\udd2f\ud83d\udd25",
    'Stop taking your product photos like THIS \u274c',
    'Turn any picture to a video',
    'This changes everything for e-commerce',
    'POV: you just discovered this tool',
    'Wait for it\u2026 \ud83d\udc40',
    "Your competitors don't want you to know this",
    'The easiest way to boost your ads',
  ],
};

export default PREDEFINED_TITLES;
